<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationHamburger.vue is part of event_pass_client.dev.   -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationHamburger.vue can not be copied and/or distributed          -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 17:15-->

<template>
    <div id="main-side-nav--hamburger"
         class="px-2 bd-highlight z-index-2">
        <button :id="button_id"
                type="button"
             v-on:click="executeSideNav()"
             class="main-nav--user-actions--link button-collapse cursor-pointer border-0 main-side-nav--hamburger">
            <i class="material-icons md-36"
               aria-hidden="true">menu</i>
        </button>
    </div>
</template>

<script>
	import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

	export default {
		name: "main-navigation-hamburger",
		components: {},
		props: ['side_nav'],
		created() {
		},
		destroyed() {
		},
		mounted() {
		},
		data() {
			return {
				id: uniqueId('main-side-nav'),
				button_id: uniqueId('main-side-nav--button'),
				active: false

			}
		},
		methods: {
			executeSideNav() {
				this.active = !this.active;
				this.$emit('controller', {
					active: this.active
				});
			}
		},
		watch: {
			'side_nav.active': function (data) {
				this.active = data;
			}
		},
		computed: {}
	}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationHamburger.vue